'use strict';
module.exports = function applyAttributes(element, attributes) {
	if (!element || !attributes) {
		return element;
	}
	Object.keys(attributes).forEach(key => {
		element.setAttribute(key, attributes[key]);
	});
	return element;
};
